import React, { useState } from "react";
import ReactDOM from "react-dom";
import Insurance from "../../contracts/Insurance.json";
import Web3 from "web3";
import ipfs from "./ipfs";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { getProfile } from "../temp/utils";
const crypto = require("crypto");
require("dotenv").config();

const PatientClaim = () => {
	const [ailment, setAilment] = useState("");
	const [date, setDate] = useState("");
	const [hospital_name, setHospital_name] = useState("");
	const [cost, setCost] = useState(0);
	const [message, setMessage] = useState("");
	const [buffer, setBuffer] = useState(null);
	const [ipfsHash, setIPfsHash] = useState("");
	const creds = JSON.parse(localStorage.getItem("creds"));

	async function capturefile(event) {
		event.stopPropagation();
		event.preventDefault();
		const file = event.target.files[0];
		let reader = new window.FileReader();
		reader.readAsArrayBuffer(file);
		reader.onloadend = () => convertToBuffer(reader);
	}

	async function convertToBuffer(reader) {
		const buffer = await Buffer.from(reader.result);
		setBuffer(buffer);
		const algorithm = "aes-256-cbc";
		const secretKey = process.env.REACT_APP_SECRET_KEY;
		const iv = process.env.REACT_APP_IV;
		console.log(secretKey == "(H+MbQeThWmZq3t6w9z0C&F)J@NcRfUj", secretKey, "(H+MbQeThWmZq3t6w9z0C&F)J@NcRfUj");
		const cipher = crypto.createCipheriv(algorithm, secretKey, iv);
		const crypted = Buffer.concat([cipher.update(buffer), cipher.final()]);
		const uploadResult = await ipfs.add(crypted);
		const hash = uploadResult.path;
		console.log(hash);
		setIPfsHash(hash);
	}

	async function signCheck() {
		const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
		const accounts = await web3.eth.getAccounts();
		let msg = "Hackathon";
		let hehe = await web3.eth.personal.sign(msg, accounts[0]);
		const signingAddress = await web3.eth.accounts.recover(msg, hehe);
		return signingAddress === accounts[0];
	}

	async function handleClick(event) {
		event.preventDefault();
		const ethereum = window.ethereum;
        const web3 = window.web3;
        const web3Instance = new Web3(ethereum);
        // const enabledWeb3 = await ethereum.enable();
		const accounts = await web3Instance.eth.getAccounts();
		const accountAddress = await accounts[0];
		const networkId = await web3Instance.eth.net.getId();
		const deployedNetwork = Insurance.networks[networkId];
		const instance = new web3Instance.eth.Contract(Insurance.abi, deployedNetwork && deployedNetwork.address);
		setCost(Number(cost));
		if (!signCheck()) {
			alert("Please sign in to continue");
		}
		const data = await getProfile(creds.access);
		console.log(data);
		// console.log(data[0].patient[0]);
		await instance.methods.newClaim(data[0].name, Number(data[0].age), data[0].sex, cost, ailment, date, hospital_name, ipfsHash).send({ from: accountAddress, gas: 2100000 });
		const res = await instance.methods.seeClaimsbyPatient().call();
		setMessage("Record Created");
		// const ethereum = window.ethereum;
        // const web3 = window.web3;
        // const web3Instance = new Web3(ethereum);
        // const enabledWeb3 = await ethereum.enable();
        // const account = await web3Instance.eth.getAccounts();
        // const accountAddress = await account[0];
        // console.log(accountAddress);
	}
	return (
		<div className="container container-fluid login-conatiner">
			<div style={{ padding: "5px" }}>
				<div className="d-flex flex-row-reverse btn btn-dark btn-lg btn-block">
					<Link to="/logout">
						<Button variant="secondary">Logout</Button>
					</Link>{" "}
					<Link to="/patient/list">
						<Button style={{ marginRight: "10px" }} variant="secondary">
							See All claims
						</Button>
					</Link>{" "}
					<Link style={{ marginRight: "950px" }} to="/patient/home">
						<Button variant="secondary">Home</Button>
					</Link>{" "}
				</div>
			</div>
			<div className="outer">
				<div className="inner">
					<form>
						<h2 className="text-center">File Claim</h2>
						<div className="form-group">
							<input type="text" value={ailment} onChange={(event) => setAilment(event.target.value)} className="form-control" placeholder="Ailment" />
						</div>
						<div className="form-group">
							<input type="Date" value={date} onChange={(event) => setDate(event.target.value)} className="form-control" placeholder="date" />
						</div>
						<div className="form-group">
							<input type="text" value={hospital_name} onChange={(event) => setHospital_name(event.target.value)} className="form-control" placeholder="Hospital Name" />
						</div>
						<div className="form-group">
							<input type="number" value={cost} onChange={(event) => setCost(event.target.value)} className="form-control" placeholder="Cost" />
						</div>
						<div className="form-group">
							<input type="file" onChange={capturefile} />
						</div>
						<div className="form-group">
							<button onClick={handleClick} type="submit" className="btn btn-dark btn-lg btn-block" style={{ marginLeft: "37.5%" }}>
								Submit
							</button>
						</div>
						{message && <p className="alert alert-danger fade in">{message}</p>}
						<div className="clearfix" />
						<img src="" id="imp"></img>
					</form>
				</div>
			</div>
		</div>
	);
};

export default PatientClaim;
